import React from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import routes from "../../routes";
import * as webviewUtils from "../../utils/webview";
import AppContext from "../../contexts/AppContext";
import Creative from "../../photolab/Creative";
import processingManager from "../../photolab/ProcessingManager";
import i18n from "../../i18n";
import {hitEvent, hits, logCreativeResult, logEvent, userEvents} from "../../utils/log";
import {assetUrl, debounce, runOnceByLocalStorage} from "../../utils/etc";
import CreativeView from "../CreativeView/CreativeView";
import {
  webviewAnalyticsEvent,
  webviewConsumable,
  webviewPreloadRewardedAd, webviewShowBanner
} from "../../utils/webview";
import clientStorage from "../../utils/client-storage";
import inappsHelper from "../../helpers/inapps.helper";
import {saveAs} from "file-saver";
import {
  creativeIsPaywall,
  creativeName,
  resolveCreativeShareFileName, resolveCreativeShareFileUrl,
  transformToDownloadUrl
} from "../../utils/creative";
import {createAnimatedCreative, createCreativeByConfig} from "../../photolab/config";
import TouchEffect from "../../components/TouchEffect/TouchEffect";
import ShareModal from "../../components/ShareModal";
import watermarkHandler from "../../utils/watermark.handler";
import Loader from "../../components/Loader/Loader";
import FileChooseButton from "../../components/FileChooseButton";
import DropdownSelectorsWrapper from '../../components/DropdownSelector/DropdownSelectorsWrapper';
import Header from '../../components/Header/Header';
import {BtnsGroupStyled, ButtonStyled, ButtonChooseContainerStyled, ContainerStyled, ParentStyled, SliderContainerStyled, SliderSlidesCountStyled, SliderSlidesCountValueStyled, SpinnerStyled, ImageContextInputStyled, ImageContextLabelStyled, ImageContextStyled} from './ResultPage.style';
import {goToProcessing} from "../../utils/url";
import {isWebviewBuild} from "../../utils/config.utils";
import Processing from "../../photolab/Processing";
import {bodyKeys, contextTypeKeys, extraKeys, stylizationKeys} from "../../photolab/etc";
import {EffectCreative} from 'swiper';
import Notification from '../../components/Notification/Notification';
import buildInfo from "../../utils/build-info";
import InstagramModal from "./InstagramModal";
import {signalEvent, signals} from "../../utils/signals";
import BannerView from "../BannerView";
import {generatePath} from "react-router";

export const watermarkConfig = {
  url: assetUrl("/assets/watermarks/hotifyme2.png"),
  position: "bottom-right",
  x: 3, // %
  y: 1, // %
  percentage: 30,
};

export default class ResultPage extends React.Component {

  state = {
    isReady: false,
    lastChosenIndex: 0,
    rewardedAdIsLoaded: false,
    isDownloadProcessing: false,
    isRedirectionProcessing: false,
    animatedCreative: null,
    showNotification: false,
    processingSession: null,
  };

  activeIndex = 0;
  swiperRef = React.createRef();
  vertivalSwipersRefs = {};

  componentDidMount() {
    window.webviewEventsListeners.tabSelected.subscribe((millis) => {
      if (millis > 0) {
        debounce("ResultPage.handleWebviewTabSelected", 300, () => {
          hitEvent(hits.RESULT_VISIT);
          logEvent(userEvents.PAGE_RESULT);
          webviewAnalyticsEvent("result_screen_shown", [
            clientStorage.getSelectedPhotosAmount(),
          ]);
        });
      }
    }, true);

    window.webviewEventsListeners.rewardedAdClosed.setListener((flag) => {
      if (flag && processingManager.processing) {
        processingManager.processing.setExtra("rewarded_is_shown", true);
        processingManager.processing.creatives.forEach((creative) => {
          if (creative.getExtra(Creative.EXTRA_IS_PAYABLE, false)) {
            creative.setExtra(Creative.EXTRA_IS_PAID, true);
          }
        });
        processingManager.update();
      }
    });

    if (window.clientConfig.isWeb) {
      logEvent(userEvents.PAGE_RESULT);
    }

    if (window.clientConfig.isWebview) {
      if (window.clientConfig.features.isRewardedAdModel) {
        webviewUtils.webviewIsRewardedAdPreloaded(window.clientConfig.features.rewardedAdUnitId).then((isLoaded) => {
          this.setState({rewardedAdIsLoaded: isLoaded});
        });
      }

      webviewUtils.webviewCheckInstalledApps((apps) => {
        this.context.setInstalledApps(apps);
      });
    }

    processingManager.addOnProcessingChangeHandler(this.handleProcessingChanged);

    if (processingManager.processing === null) {
      const restoredProcessing = processingManager.restore();

      if (restoredProcessing) {
        try {

          processingManager.start(restoredProcessing);
          this.activeIndex = processingManager.processing?.getExtra("active_index", 0);

          this.setState({isReady: true});
        } catch (err) {
          console.error(err);
          processingManager.clear();
          this.props.history.replace(generatePath(routes.INDEX, {user_id: window.clientConfig.userId}) + "?reason=result_processing_restore_fail");
        }
      } else {
        processingManager.clear();
        this.props.history.replace(generatePath(routes.INDEX, {user_id: window.clientConfig.userId}) + "?reason=result_no_processing");
      }
    } else {
      this.setState({isReady: true});
      this.handleProcessingChanged();
    }
  }

  componentWillUnmount() {
    processingManager.removeOnProcessingChangeHandler(this.handleProcessingChanged);
  }

  handleProcessingChanged = () => {
    const processing = processingManager.processing;
    if (processing) {
      const version = processing.getExtra(extraKeys.version, 0);
      if (version < window.appConfig.processings.latestVersion) {
        processingManager.clear();
        this.props.history.replace(generatePath(routes.INDEX, {user_id: window.clientConfig.userId}) + "?reason=result_processing_version");
      }

      processing.creatives
        .filter((c) => c.getExtra(Creative.EXTRA_AUTOSAVE, false) && c.isFinished)
        .forEach((c) => {
          c.removeExtra(Creative.EXTRA_AUTOSAVE);
          processingManager.update();

          if (c.isProcessed) {
            this.handleShare("save", c);
          }
        });

      this.setState({
        _creativesTotal: processing.creatives.length,
        _creativesProcessed: processing.creatives.filter((c) => c.isProcessed).length,
        _creativesPending: processing.creatives.filter((c) => c.isPending).length,
        _creativesFailed: processing.creatives.filter((c) => c.isFailed).length,
      });

      // processing.getItemsOrder().forEach((item, position) => {
      //   const selectedIndex = processing.getCreativesByPosition(position).findIndex((c) => c.isSelected);
      //   if (selectedIndex > -1 && this.vertivalSwipersRefs[position]) {
      //     if (this.vertivalSwipersRefs[position].activeIndex !== selectedIndex) {
      //       this.vertivalSwipersRefs[position].slideTo(selectedIndex);
      //     }
      //   }
      // });
    }
  };

  getCreativeByIndex = (position) => {
    const items = processingManager.processing.getItemsOrder();
    if (position >= items.length) {
      return null;
    }

    let creative = processingManager.processing.getSelectedCreativeByPosition(position);

    if (!creative) {
      const contextType = processingManager.processing.getExtra(extraKeys.contextType);

      creative = new Creative();
      creative.setId(`dummy-${position}-${contextType}`);
      creative.setTemplateId("dummy");
      creative.setExtra(extraKeys.contextType, processingManager.processing.getExtra(extraKeys.contextType));

      if (position >= window.clientConfig.features.freeCreativesAmount) {
        creative.setExtra(Creative.EXTRA_IS_PAYABLE, true);
      }

      if (window.clientConfig.features.isSubscribeModel && window.clientConfig.isPro) {
        creative.setExtra(Creative.EXTRA_IS_PAID, true);
      }
    }



    return creative;
  };

  getPurchase = () => {
    return this.context.purchases
      .filter((p) => p.product_id === this.context.purchaseSku.sku)
      .sort((a, b) => b.available - a.available)
      .first();
  };

  canPay = (position) => {
    if (position < window.clientConfig.features.freeCreativesAmount) {
      return true;
    }

    if (window.clientConfig.features.isSubscribeModel) {
      return window.clientConfig.isPro;
    }

    if (window.clientConfig.features.isRewardedAdModel && this.state.rewardedAdIsLoaded) {
      return processingManager.processing.getExtra("rewarded_is_shown", false);
    }

    const purchase = this.getPurchase();

    return purchase && purchase.available > 0;
  }

  handleActiveIndexChange = (swiper) => {
    const position = swiper.activeIndex;
    const processing = processingManager.processing;
    const creative = this.getCreativeByIndex(position);

    if (creative.isDummy) {
      const canPay = this.canPay(position);
      const currentCreative = processing.getSelectedCreativeByPosition(position);

      const nextCreative = createCreativeByConfig(
        processing,
        processing.getItemByPosition(position),
        {
          gender: processing.getExtra(extraKeys.gender),
          stylization: processing.getExtra(extraKeys.stylization),
          body: processing.getExtra(extraKeys.body),
          contextType: processing.getExtra(extraKeys.contextType),
        }
      );

      if (canPay) {
        this.logStartCreative(nextCreative, position);

        nextCreative.setExtra(Creative.EXTRA_IS_PAYABLE, true);
        nextCreative.setExtra(Creative.EXTRA_IS_PAID, true);
        nextCreative.setExtra(Creative.EXTRA_POSITION, position);
        processing.addCreative(nextCreative);

        nextCreative.setAsSelected(true);
        currentCreative && currentCreative.setAsSelected(false);

        processingManager.update();

        if (window.clientConfig.features.isPurchaseModel) {
          const purchase = this.getPurchase();

          inappsHelper.consume(purchase.id, 1).then((res) => {
            this.context.updatePurchase(res.data);
          });
        }
      }
    }

    this.activeIndex = position;
    processingManager.processing.setExtra("active_index", position);
    processingManager.update();
  }

  handleVerticalActiveIndexChange = (swiper, position) => {
    if (isNaN(swiper.realIndex)) {
      return;
    }

    const currentCreative = this.getCreativeByIndex(position);
    const orderedCreatives = window.clientConfig.features.showCards
      ? processingManager.processing.getCreativesByPosition(position)
        .filter((c) => c.getExtra(extraKeys.gender) === currentCreative.getExtra(extraKeys.gender))
        .sort((a, b) => b.getExtra(Creative.EXTRA_STARTED_AT) - a.getExtra(Creative.EXTRA_STARTED_AT))
      : [currentCreative];

    const nextCreative = orderedCreatives[swiper.realIndex];

    if (currentCreative.id !== nextCreative.id) {
      currentCreative.setAsSelected(false);
      nextCreative.setAsSelected(true);
      processingManager.update();
    }
  }

  startPurchaseOrAd = () => {
    if (window.clientConfig.features.isSubscribeModel) {
      this.handleSubscribeButtonClick();
    } else if (window.clientConfig.features.isRewardedAdModel && this.state.rewardedAdIsLoaded) {
      webviewUtils.webviewShowRewardedAd(
        window.clientConfig.features.rewardedAdUnitId,
        "onRewardedAdShown",
        "onRewardedAdClosed"
      );
    } else if (window.clientConfig.features.isPurchaseModel) {
      this.handlePurchaseButtonClick();
    }
  };

  handleDownloadButtonClick = () => {
    const processing = processingManager.processing;
    const position = this.activeIndex;
    const creative = this.getCreativeByIndex(position);

    hitEvent(hits.DOWNLOAD);
    logEvent(userEvents.DOWNLOAD, {
      group: creative.group,
      template_id: creative.templateId,
      position: position,
      section_name: processing.getExtra(extraKeys.sectionName),
      section_position: processing.getExtra(extraKeys.sectionPosition),
      block_name: processing.getExtra(extraKeys.blockName),
      block_position: processing.getExtra(extraKeys.blockPosition),
    });

    this.logShareCreative(creative, position, "download");

    logCreativeResult(
      creativeName(creative),
      processingManager.processing.files.map((f) => ({url: f.url})),
      [{url: creative.result}],
      true,
      {
        gender: creative.getExtra(extraKeys.gender),
        body: creative.getExtra(extraKeys.body),
        stylization: creative.getExtra(extraKeys.stylization),
        context_type: creative.getExtra(extraKeys.contextType),
        is_safe_prompt: creative.getExtra("is_safe_prompt"),
        answers: processingManager.processing.getExtra("answers"),
        age_verdict: processingManager.processing.getExtra("age_verdict"),
        bodies_states: processingManager.processing.getExtra("bodies_states"),
        combo: creative.getExtra(Creative.EXTRA_COMBO_STEPS),
        result_moderation_result: creative.getExtra("result_moderation_result", {}),
        source_moderation_result: creative.getExtra("source_moderation_result", {}),
        moderation_tries: (creative.getExtra("tries_by_moderation", 0) + 1),
      }
    );

    if (window.clientConfig.isWebview) {
      webviewUtils.webviewCheckInstalledApps((apps) => {
        this.context.setInstalledApps(apps);
      });
    }

    const fileName = resolveCreativeShareFileName();

    if (creative.getFile(fileName)) {
      this.handleDownload(creative);
      return;
    }

    this.setState({isDownloadProcessing: true});

    watermarkHandler(
      creative.getFile("raw"),
      window.clientConfig.isPro ? null : watermarkConfig,
      null
    ).then((resultUrl) => {
      creative.setFile(fileName, resultUrl);
      this.setState({isDownloadProcessing: false});
      this.handleDownload(creative);
    }).catch((error) => {
      console.log(error);
      this.setState({isDownloadProcessing: false});
      this.handleDownload(creative);
    });
  };

  handleDownload = (creative) => {
    const imageUrl = resolveCreativeShareFileUrl(creative);

    if (window.clientConfig.isWebview) {
      webviewUtils.webviewShare({
        providers: window.clientConfig.isWebviewIOS ? encodeURIComponent("[0]") : "[0]",
        imageUrl: encodeURIComponent(imageUrl),
      });

      const providers = {
        ...this.context.installedApps,
        ...{
          tiktok: false,
          facebookMessenger: false,
        },
        ...(isWebviewBuild(8, 99999999) ? {} : {snapchat: false})
      };

      this.context.pushModal(<ShareModal
        key="ResultPage_ShareModal"
        slider={this.swiperRef}
        hashtag={"#hotify"}
        creativeIndex={this.activeIndex}
        providers={providers}
        creative={creative}
        onCreateAnimation={(autosave) => this.handleAnimateCreative(creative, autosave)}
        onRetryCreative={this.handleRetryCreative}
        onShare={this.handleShare}
        onClose={this.handleCloseShareModal}
        onDismissed={this.handleShareModalDismissed}
      />);
    } else {
      const fileName = imageUrl.substring(imageUrl.lastIndexOf("/") + 1);
      saveAs(transformToDownloadUrl(imageUrl), fileName);
    }

    if (!processingManager.processing.hasExtra("signal_download_is_sent")) {
      processingManager.processing.setExtra("signal_download_is_sent", true);
      signalEvent(signals.download);
    }
  };

  handleCloseShareModal = (show, index) => {
    this.setState({showNotification: show, lastChosenIndex: index});
  }

  handleShareModalDismissed = () => {
    if (this.context.installedApps.instagram) {
      runOnceByLocalStorage("show_instagram_modal", () => {
        logEvent("instagram_modal_shown");
        this.context.pushModal(<InstagramModal key="ResultPage_InstagramModal" />);
      });
    }
  };

  handleRetryCreative = (creative) => {
    creative.markAsPending();
    creative.removeExtra(Creative.EXTRA_STARTED_AT);

    processingManager.retryCreative(creative);
  };

  handleShare = (provider, creative) => {
    const imageUrl = resolveCreativeShareFileUrl(creative);

    const providers = [];
    provider === "save" && providers.push(webviewUtils.shareProvidersIds.save);
    provider === "snapchat" && providers.push(webviewUtils.shareProvidersIds.snapchat);
    provider === "instagram" && providers.push(webviewUtils.shareProvidersIds.instagram);
    provider === "facebook" && providers.push(webviewUtils.shareProvidersIds.facebook);
    provider === "whatsapp" && providers.push(webviewUtils.shareProvidersIds.whatsapp);
    provider === "telegram" && providers.push(webviewUtils.shareProvidersIds.telegram);

    webviewUtils.webviewShare({
      providers: "[" + providers.join(",") + "]",
      imageUrl: encodeURIComponent(imageUrl),
    });

    this.logShareCreative(creative, this.activeIndex, provider);
  };

  handleAnimateCreative = (creative, autosave) => {
    const animatedCreative = createAnimatedCreative(
      processingManager.processing,
      processingManager.processing.files[0].url,
      creative,
      autosave
    );

    this.setState({animatedCreative});

    processingManager.processing.addCreative(animatedCreative);
    processingManager.update();
  }

  handleNextButtonClick = () => {
    const creative = this.getCreativeByIndex(this.activeIndex);
    if (creativeIsPaywall(creative)) {
      debounce("handleNextButtonClick_startPurchaseOrAd", 300, () => {
        this.startPurchaseOrAd();
      });
      return;
    }

    this.swiperRef.slideNext();
  };

  handleBackButtonClick = () => {
    processingManager.clear();
    this.props.history.replace(generatePath(routes.INDEX, {user_id: window.clientConfig.userId}) + "?reason=result_backbutton");
  };

  handleSubscribeButtonClick = () => {
    webviewShowBanner("web_hotify");

    webviewAnalyticsEvent("continue_button_tapped", [
      clientStorage.getSelectedPhotosAmount(),
      this.activeIndex + 1,
    ]);

    // const skuItem = this.context.subscriptionSku;
    //
    // processingManager.processing.setExtra("awaiting_billed_sku", skuItem.sku);
    // processingManager.update();
    //
    // hitEvent(hits.PURCHASE_CLICK);
    // logEvent(userEvents.PURCHASE_CLICK, {
    //   sku: skuItem.sku,
    //   type: "subscription",
    // });
    //
    // clientStorage.setAwaitingBilledSku(skuItem.sku);
    //
    // webviewInApp(skuItem.sku);
  };

  handlePurchaseButtonClick = () => {
    const skuItem = this.context.purchaseSku;

    processingManager.processing.setExtra("awaiting_billed_sku", skuItem.sku);
    processingManager.update();

    hitEvent(hits.PURCHASE_CLICK);
    logEvent(userEvents.PURCHASE_CLICK, {
      sku: skuItem.sku,
      type: "inapp",
    });
    clientStorage.setAwaitingBilledSku(skuItem.sku);

    webviewConsumable(skuItem.sku);
  };

  logStartCreative(creative, position) {

  }

  logShareCreative(creative, position, provider) {
    webviewAnalyticsEvent("save_and_share", [
      clientStorage.getSelectedPhotosAmount(),
      position + 1,
      creative.templateId,
      creative.getExtra(extraKeys.body),
      creative.getExtra(extraKeys.gender),
      provider,
    ], {
      wt_hotify: {
        preproc: creative.getExtra(extraKeys.stylization) === stylizationKeys.glamour ? "glamour" : "no",
        orig_bg: creative.getExtra(extraKeys.contextType) === contextTypeKeys.original ? "yes" : "no",
        block_cnt: clientStorage.getSelectedBlocksAmount(),
      }
    });
  }

  handleGenderChanged = (nextGender) => {
    const processing = processingManager.processing;
    const currentCreative = processing.getSelectedCreativeByPosition(this.activeIndex);

    if (currentCreative.getExtra(extraKeys.gender) === nextGender) {
      return;
    }

    const itemsMale = processing.getExtra(Processing.EXTRA_CONFIGS_ORDER_MALE);
    const itemsFemale = processing.getExtra(Processing.EXTRA_CONFIGS_ORDER_FEMALE);
    const currentLength = this.activeIndex + 1;

    if (itemsMale.length < currentLength) {
      const startLength = itemsMale.length;
      for (let i = startLength; i < currentLength; i++) {
        itemsMale.push(itemsMale[i % startLength]);
      }
      processing.setExtra(Processing.EXTRA_CONFIGS_ORDER_MALE, itemsMale);
    }

    if (itemsFemale.length < currentLength) {
      const startLength = itemsFemale.length;
      for (let i = startLength; i < currentLength; i++) {
        itemsFemale.push(itemsFemale[i % startLength]);
      }
      processing.setExtra(Processing.EXTRA_CONFIGS_ORDER_FEMALE, itemsFemale);
    }

    let nextCreative = processing.getCreativeByParams(
      this.activeIndex,
      nextGender,
      currentCreative.getExtra(extraKeys.contextType),
      currentCreative.getExtra(extraKeys.body),
      currentCreative.getExtra(extraKeys.stylization)
    );

    if (!nextCreative) {
      nextCreative = createCreativeByConfig(
        processing,
        processing.getItemByPosition(this.activeIndex, nextGender),
        {
          gender: nextGender,
          stylization: currentCreative.getExtra(extraKeys.stylization),
          body: currentCreative.getExtra(extraKeys.body),
          contextType: currentCreative.getExtra(extraKeys.contextType),
        }
      );

      nextCreative.setExtra(Creative.EXTRA_POSITION, this.activeIndex);
      processing.addCreative(nextCreative);
    }

    currentCreative.setAsSelected(false);
    nextCreative.setAsSelected(true);


    processing.setExtra(extraKeys.gender, nextGender);
    processing.setExtra(`result_state_hash:${this.activeIndex}`, Date.now());
    processingManager.update();

    this.logStartCreative(nextCreative, this.activeIndex);
  };

  handleStylizationChanged = (nextStylization) => {
    const processing = processingManager.processing;
    const currentCreative = processing.getSelectedCreativeByPosition(this.activeIndex);

    if (currentCreative.getExtra(extraKeys.stylization) === nextStylization) {
      return;
    }

    let nextCreative = processing.getCreativeByParams(
      this.activeIndex,
      currentCreative.getExtra(extraKeys.gender),
      currentCreative.getExtra(extraKeys.contextType),
      currentCreative.getExtra(extraKeys.body),
      nextStylization
    );

    if (!nextCreative) {
      nextCreative = createCreativeByConfig(
        processing,
        processing.getItemByPosition(this.activeIndex),
        {
          gender: currentCreative.getExtra(extraKeys.gender),
          stylization: nextStylization,
          body: currentCreative.getExtra(extraKeys.body),
          contextType: currentCreative.getExtra(extraKeys.contextType),
        }
      );

      nextCreative.setExtra(Creative.EXTRA_POSITION, this.activeIndex);
      processing.addCreative(nextCreative);
    }

    currentCreative.setAsSelected(false);
    nextCreative.setAsSelected(true);

    processing.setExtra(extraKeys.stylization, nextStylization);
    processing.setExtra(`result_state_hash:${this.activeIndex}`, Date.now());
    processingManager.update();

    this.logStartCreative(nextCreative, this.activeIndex);
  };

  handleBodySizeChanged = (nextBody) => {
    const processing = processingManager.processing;
    const currentCreative = processing.getSelectedCreativeByPosition(this.activeIndex);

    if (currentCreative.getExtra(extraKeys.body) === nextBody) {
      return;
    }

    let nextCreative = processing.getCreativeByParams(
      this.activeIndex,
      currentCreative.getExtra(extraKeys.gender),
      currentCreative.getExtra(extraKeys.contextType),
      nextBody,
      currentCreative.getExtra(extraKeys.stylization)
    );

    if (!nextCreative) {
      nextCreative = createCreativeByConfig(
        processing,
        processing.getItemByPosition(this.activeIndex),
        {
          gender: currentCreative.getExtra(extraKeys.gender),
          stylization: currentCreative.getExtra(extraKeys.stylization),
          body: nextBody,
          contextType: currentCreative.getExtra(extraKeys.contextType)
        }
      );

      nextCreative.setExtra(Creative.EXTRA_POSITION, this.activeIndex);
      processing.addCreative(nextCreative);
    }

    currentCreative.setAsSelected(false);
    nextCreative.setAsSelected(true);

    processing.setExtra(extraKeys.body, nextBody);
    processing.setExtra(`result_state_hash:${this.activeIndex}`, Date.now());
    processingManager.update();

    this.logStartCreative(nextCreative, this.activeIndex);
  };

  handleContextTypeChanged = (nextContextType) => {
    const processing = processingManager.processing;
    const currentCreative = processing.getSelectedCreativeByPosition(this.activeIndex);

    if (currentCreative.getExtra(extraKeys.contextType) === nextContextType) {
      return;
    }

    const nextContextTypeIsOriginal = nextContextType === contextTypeKeys.original;

    let nextCreative = processing.getCreativeByParams(
      this.activeIndex,
      currentCreative.getExtra(extraKeys.gender),
      nextContextType,
      currentCreative.getExtra(extraKeys.body),
      currentCreative.getExtra(extraKeys.stylization)
    );

    if (!nextCreative) {
      nextCreative = createCreativeByConfig(
        processing,
        processing.getItemByPosition(this.activeIndex),
        {
          gender: currentCreative.getExtra(extraKeys.gender),
          stylization: currentCreative.getExtra(extraKeys.stylization),
          body: nextContextTypeIsOriginal ? bodyKeys.slim : currentCreative.getExtra(extraKeys.body),
          contextType: nextContextType
        }
      );

      nextCreative.setExtra(Creative.EXTRA_POSITION, this.activeIndex);
      processing.addCreative(nextCreative);
    }

    currentCreative.setAsSelected(false);
    nextCreative.setAsSelected(true);

    processing.setExtra(extraKeys.contextType, nextContextType);
    processing.setExtra(`result_state_hash:${this.activeIndex}`, Date.now());
    processingManager.update();

    this.logStartCreative(nextCreative, this.activeIndex);
  };

  handleChoosePhotoButtonClick = () => {
    signalEvent(signals.photoSelectClick);
    buildInfo.fetch().then();

    if (window.clientConfig.features.isRewardedAdModel) {
      webviewPreloadRewardedAd(window.clientConfig.features.rewardedAdUnitId);
    }
  };

  handleFilesSelected = (files) => {
    this.setState({
      isRedirectionProcessing: true,
    });

    hitEvent(hits.RESULT_PHOTO_SELECT);

    processingManager.clear();

    goToProcessing(this.props.history, files);
  };

  handleRemoveNotification = () => {
    this.setState({
      animatedCreative: null,
      showNotification: false
    });
  }

  handleShowAnimateCreative = () => {
    const creative = this.getCreativeByIndex(this.state.lastChosenIndex);

    const providers = {
      ...this.context.installedApps,
      ...{
        tiktok: false,
        facebookMessenger: false,
      },
      ...(isWebviewBuild(8, 99999999) ? {} : {snapchat: false})
    };

    this.context.pushModal(<ShareModal
      key="ResultPage_ShareModal"
      slider={this.swiperRef}
      hashtag={"#hotify"}
      providers={providers}
      creative={creative}
      creativeIndex={this.activeIndex}
      initialSlide={1}
      onCreateAnimation={(autosave) => this.handleAnimateCreative(creative, autosave)}
      onRetryCreative={this.handleRetryCreative}
      onShare={this.handleShare}
      onClose={this.handleCloseShareModal}
    />);

    this.handleRemoveNotification();
  }

  handleCreativeOptions = (position, creative) => {
    const itemConfig = processingManager.processing.getItemByPosition(
      position,
      creative.getExtra(extraKeys.gender)
    );

    const isMultiface = processingManager.processing.getExtra(Processing.EXTRA_IS_MULTIFACE);
    const isUndressingBlock = this.isUndressingBlock();
    const canSwitchBodies = ["hotify", "ipadapter"].includes(itemConfig.type) && itemConfig.params["curve"] !== undefined;
    const canSwitchStylization = !isUndressingBlock
      && itemConfig.type !== "bodyeditor_20230630_d12"
      && itemConfig.type !== "d22sdxl"
      && itemConfig.type !== "ipadapter"
    ;

    const creativeOptions = [{
      hidden: creative.isDummy || creative.isPending,
      value: creative.getExtra(extraKeys.gender),
      items: [{
        key: "female",
        icon: "gender-female",
        label: i18n.t("processing_female_button"),
      }, {
        key: "male",
        icon: "gender-male",
        label: i18n.t("processing_male_button"),
      }],
      onChange: this.handleGenderChanged,
    }, {
      hidden: creative.isDummy || creative.isPending || !canSwitchStylization,
      value: creative.getExtra(extraKeys.stylization),
      items: [{
        key: "glamour",
        icon: "styles-glamour",
        label: i18n.t("processing_glamour_button"),
      }, {
        key: "no",
        icon: "styles-realistic",
        label: i18n.t("processing_realistic_button"),
      }],
      onChange: this.handleStylizationChanged,
    }, {
      hidden: creative.isDummy || creative.isPending || creative.getExtra(extraKeys.contextType) === contextTypeKeys.original || !canSwitchBodies,
      value: creative.getExtra(extraKeys.body),
      items: [{
        key: "slim",
        icon: "styles-slim",
        label: i18n.t("bodysize_slim"),
      }, {
        key: "curve",
        icon: "styles-normal",
        label: creative.getExtra(extraKeys.gender) === "male" ? i18n.t("bodysize_bigger") : i18n.t("bodysize_curve"),
      }],
      onChange: this.handleBodySizeChanged,
    }];

    if (isMultiface) {
      creativeOptions.shift();
      creativeOptions.pop();
    }

    return creativeOptions;
  }

  renderItem = (position) => {
    const useVerticalCards = window.clientConfig.features.showCards;
    const creative = this.getCreativeByIndex(position);
    const isActive = position === this.activeIndex;
    const isOverlayed = creativeIsPaywall(creative);

    const originalImageUrl = processingManager.processing.files.first().url;
    const resultStateHash = processingManager.processing.getExtra(`result_state_hash:${position}`, 0);

    if (useVerticalCards) {
      const orderedCreatives = !creative.isDummy
        ? processingManager.processing.getCreativesByPosition(position)
          .filter((c) => c.getExtra(extraKeys.gender) === creative.getExtra(extraKeys.gender))
          .sort((a, b) => b.getExtra(Creative.EXTRA_STARTED_AT) - a.getExtra(Creative.EXTRA_STARTED_AT))
        : [creative];
      const initialSlide = orderedCreatives.findIndex((c) => c.isSelected);

      return <SwiperSlide key={`slide-${position}-${resultStateHash}`}>
        <Swiper
          onSwiper={(ref) => this.vertivalSwipersRefs[position] = ref}
          allowSlideNext={creative.isFinished}
          allowSlidePrev={creative.isFinished}
          className={window.clientConfig.features.showCards ? "cards-result" : ""}
          direction="vertical"
          modules={[EffectCreative]}
          effect={"creative"}
          initialSlide={initialSlide !== -1 ? initialSlide : 0}
          creativeEffect={{
            prev: {
              translate: [0, "17%", 0],
              scale: 0.7,
              opacity: 0.8
            },
            next: {
              scale: 0.8,
              translate: [0, "11%", 0],
              opacity: 0.8
            },
          }}
          loop
          onActiveIndexChange={(swiper) => this.handleVerticalActiveIndexChange(swiper, position)}>
          {orderedCreatives.map((item) => {
            return <SwiperSlide key={item.id}>
              <DropdownSelectorsWrapper selectors={this.handleCreativeOptions(position, item)} />
              <CreativeView
                isSelected={isActive}
                creative={item}
                position={position}
                isOverlayed={isOverlayed}
                originalImageUrl={originalImageUrl}
              />
              {/*<BannerView hidden={!isOverlayed} isOnScreen={isOverlayed && isActive} />*/}
            </SwiperSlide>
          })}
        </Swiper>
      </SwiperSlide>;
    } else {
      return <SwiperSlide key={`slide-${position}-${resultStateHash}`}>
        <DropdownSelectorsWrapper selectors={this.handleCreativeOptions(position, creative)} />
        <CreativeView
          isSelected={isActive}
          creative={creative}
          position={position}
          isOverlayed={isOverlayed}
          originalImageUrl={originalImageUrl}
        />
        {/*<BannerView hidden={!isOverlayed} isOnScreen={isOverlayed && isActive} />*/}
      </SwiperSlide>;
    }
  }

  isUndressingBlock = () => {
    const blockData = clientStorage.getLatestBlock();
    const section = this.context.config.sections.find((section) => section.name === blockData.section);
    if (section) {
      const block = section.blocks.find((block) => block.name === blockData.block);
      if (block) {
        return block.extra[extraKeys.contextType] === contextTypeKeys.original;
      }
    }

    return false;
  }

  render() {
    if (!this.state.isReady || !processingManager.processing) {
      return <React.Fragment />;
    }

    const processingsItems = processingManager.processing.getItemsOrder();
    const processingsItemsAmount = processingsItems.length;
    const activeCreative = this.getCreativeByIndex(this.activeIndex);
    const nextCreative = this.getCreativeByIndex(this.activeIndex + 1);
    const initialSlide = processingManager.processing.getExtra("active_index", 0);
    const activeCreativeIsPaywall = creativeIsPaywall(activeCreative);
    const nextButtonText = activeCreativeIsPaywall ? i18n.t("continue") : i18n.t("more");
    const activeCreativeIsLast = this.activeIndex === (processingsItemsAmount - 1);
    const isDisabledNextButton = activeCreativeIsLast
      || (!activeCreativeIsPaywall && !activeCreative.isFinished);
    const isHiddenNextButton = activeCreativeIsLast && !activeCreativeIsPaywall && activeCreative.isFinished;

    const canSlideToNext = (!activeCreativeIsPaywall && !activeCreative.isDummy && !activeCreative.isPending) // если текущий не баннер и не в процессе
      || (activeCreative.isPending && nextCreative && !nextCreative.isDummy) // если текущий в процессе но след реальная обработка
      || (!activeCreativeIsPaywall && nextCreative && creativeIsPaywall(nextCreative)) // если текущий не баннер, а след баннер
      ;

    const itemConfig = processingManager.processing.getItemByPosition(
      this.activeIndex,
      activeCreative.getExtra(extraKeys.gender)
    );

    const originalContextTipIsHidden = true; // activeCreative.isProcessed || activeCreative.isDummy || clientStorage.getString("tipIsHidden");
    const originalContextCheckboxIsHidden = this.isUndressingBlock() || itemConfig.params["original"] === undefined || Object.keys(itemConfig.params).length === 1;

    return <ParentStyled>
      {this.state.animatedCreative && this.state.animatedCreative.isProcessed && this.state.showNotification &&
        <Notification
          preview={this.state.animatedCreative.result}
          handleCloseButtonClick={this.handleRemoveNotification}
          handleNotificationClick={this.handleShowAnimateCreative}
        />
      }

      <ContainerStyled>
        <Header
          title="result"
          onHandleClick={this.handleBackButtonClick}
        />

        <SliderContainerStyled style={{maxHeight: this.sliderHeight}}>
          <Swiper
            allowSlideNext={canSlideToNext}
            centeredSlides={true}
            initialSlide={initialSlide}
            spaceBetween={10}
            slidesPerView={window.clientConfig.isWebDesktop ? 1 : 1.12}
            onActiveIndexChange={this.handleActiveIndexChange}
            onSwiper={(swiper) => this.swiperRef = swiper}
          >
            {processingsItems.map((_, position) => this.renderItem(position))}
          </Swiper>
        </SliderContainerStyled>

        <SliderSlidesCountStyled>
          {originalContextCheckboxIsHidden && <span />}
          {!originalContextCheckboxIsHidden && <React.Fragment>
            <div className="creative-promt" hidden={originalContextTipIsHidden}>
              <p>{i18n.t("original_context_tooltip")}</p>
              <SvgArrowPromt />
            </div>
            <ImageContextStyled className={(activeCreativeIsPaywall || activeCreative.isPending) ? "disabled" : ""}>
              <ImageContextInputStyled
                id="image-context"
                type="checkbox"
                disabled={activeCreativeIsPaywall || activeCreative.isPending}
                checked={activeCreative.getExtra(extraKeys.contextType) === contextTypeKeys.original}
                onChange={(e) => {
                  this.handleContextTypeChanged(e.target.checked ? contextTypeKeys.original : contextTypeKeys.template);
                  clientStorage.setString("tipIsHidden", true);
                }}
              />
              <ImageContextLabelStyled htmlFor="image-context">
                {i18n.t("original_context")}
              </ImageContextLabelStyled>
            </ImageContextStyled>
          </React.Fragment>}
          <SliderSlidesCountValueStyled>
            {this.activeIndex + 1}/{processingsItemsAmount}
          </SliderSlidesCountValueStyled>
        </SliderSlidesCountStyled>

        <BtnsGroupStyled>
          <ButtonStyled
            disabled={activeCreative.isDummy || !activeCreative.isProcessed}
            transparent
            onClick={this.handleDownloadButtonClick}>
            {i18n.t("download")}
            <TouchEffect />
          </ButtonStyled>
          <ButtonStyled
            disabled={isDisabledNextButton}
            visibilityHidden={isHiddenNextButton}
            animate
            full
            onClick={this.handleNextButtonClick}>
            {!(!activeCreativeIsPaywall && activeCreative.isPending) && nextButtonText}
            {!activeCreativeIsPaywall && activeCreative.isPending && <SpinnerStyled />}
            {(activeCreative.isFinished || activeCreativeIsPaywall) && <SvgMoreButtonArrowIcon />}
            <TouchEffect />
          </ButtonStyled>
          <ButtonChooseContainerStyled>
            <FileChooseButton
              onClick={this.handleChoosePhotoButtonClick}
              onFilesSelected={this.handleFilesSelected}>
              {i18n.t("change")}
              <TouchEffect />
            </FileChooseButton>
          </ButtonChooseContainerStyled>
        </BtnsGroupStyled>
      </ContainerStyled>

      {(this.state.isRedirectionProcessing || this.state.isDownloadProcessing) && <Loader />}
    </ParentStyled>;
  }
}

export function SvgMoreButtonArrowIcon() {
  return <svg viewBox="0 0 83 19">
    <defs>
      <clipPath id="6ablmodosa">
        <path d="M1242 0v2208H0V0h1242z" />
      </clipPath>
    </defs>
    <g clipPath="url(#6ablmodosa)" transform="translate(-1023 -1913)">
      <path d="m1086.5 1913 19 9.5-19 9.5v-8h-63v-3h63v-8z" />
    </g>
  </svg>
}

function SvgArrowPromt() {
  return <svg viewBox="0 0 105 105">
    <defs>
      <clipPath id="h4oz2cb19a">
        <path d="M1242 0v2208H0V0h1242z" />
      </clipPath>
      <clipPath id="qo6u1siszb" />
    </defs>
    <g clipPath="url(#h4oz2cb19a)" transform="translate(-150 -1615)">
      <g clipPath="url(#qo6u1siszb)" transform="rotate(135 -208.454 861.424)">
        <path fill="#D7D7D7" d="M0 .5h144H0z" />
      </g>
      <path fill="#F4C500" d="m170.887 1713.048-20.152 6.717 6.717-20.152 5.657 5.657 89.803-89.803 2.121 2.121-89.803 89.803 5.657 5.657z" />
    </g>
  </svg>;
}

ResultPage.contextType = AppContext;
